export default __webpack_public_path__ + "assets/pdf/FT_VRSP.e0ab0cfb.pdf";